module.exports = __webpack_public_path__ + "img/jf.a3895336.svg";